import React from 'react'
import { PhaseSale } from 'src/components/PhaseSale'

export function Phase2SalePage() {
  return (
    <div className="phase1-sale-page page">
      <PhaseSale
        phase={2}
        arcPrice={'$6,500'}
        terms={'1/3 available at token launch, 2/3 available after 6 months (locked)'}
      />
    </div>
  )
}
